<template lang="pug">
	.search-modal-frame(:class="modalView ? 'search-modal-frame--styled' : ''" v-show="!isMobile || (isMobile && visible) || !modalView" :role="role")
		.search-modal-overlay(:style="'background-color:'+overlayColor+';'", :class="'search-modal-overlay--'+overlayTheme")
		.search-modal(:id="modalId", :class="visible ? 'search-modal--open' : ''" ref="dialog")
			a.sr-only(href="#", aria-hidden="true", @focus="jumpToLastTabbable")
			.search-modal-dialog.sf-vertical-alignment-helper(:class="['search-modal-dialog--' + modalWidth ]")
				.sf-vertical-align-center
					.search-modal-content(:class="[!customBackgroundColor ? 'search-modal-content--' + backgroundColor : '', { 'search-modal-content--columns' : ($slots['modal-column-wide'] && $slots['modal-column-narrow']) }]")
						.search-modal__header
							button.search-modal__close-btn(v-if="closable && closeBtnVisible" ref="firstTabbable", type="button", @click.prevent="closePopup")
								<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M4.2282 1.04261C3.4305 0.244911 2.13718 0.244911 1.33948 1.04261C0.541786 1.84031 0.541787 3.13364 1.33948 3.93133L5.25991 7.85177L1.33951 11.7722C0.541816 12.5699 0.541816 13.8632 1.33951 14.6609C2.13721 15.4586 3.43054 15.4586 4.22823 14.6609L8.14863 10.7405L12.069 14.6609C12.8667 15.4586 14.16 15.4586 14.9577 14.6609C15.7554 13.8632 15.7554 12.5699 14.9577 11.7722L11.0373 7.85177L14.9578 3.93135C15.7555 3.13366 15.7555 1.84033 14.9578 1.04263C14.1601 0.244932 12.8667 0.244933 12.069 1.04263L8.14863 4.96305L4.2282 1.04261Z" fill="#52AE30"/>
								</svg>
							.search-modal-heading(v-if="headerVisible && isMobile && modalView")
								slot(name="modal-header")
						.search-modal__body(:class="[{ 'search-modal__body--columns' : ($slots['modal-column-wide'] && $slots['modal-column-narrow']) }, `search-modal__body--mobile-${mobileBodyWidth}`]")
							slot(name="modal-body")
							.search-modal__column-wide(v-if="$slots['modal-column-wide']")
								slot(name="modal-column-wide")
							.search-modal__column-narrow(v-if="$slots['modal-column-narrow']")
								slot(name="modal-column-narrow")
						.search-modal__footer(v-if="$slots['modal-footer']")
							slot(name="modal-footer")
						a.sr-only(href="#", aria-hidden="true", @focus="jumpToFirstTabbable")
</template>
<script>
import Vue from 'vue';
import VueModal from '@ui-common/vue-modal';
import isMobile from '../../../common/js/is-mobile/is-mobile';
import { tabbable } from 'tabbable';
Vue.use(VueModal);
const VueModalComponent = Vue.component('VueModal');
export default {
	mixins: [isMobile],
	name: 'SearchModal',
	extends: VueModalComponent,
	props: {
		modalView: {
			type: Boolean,
			required: true
		}
	},
	methods: {
		openPopup() {
			this.visible = true;
			// EventBus.$emit('toggle-inert', this.visible);
			// EventBus.$emit('modal-opened', this.modalId, this.payload);
			// document.body.classList.add('modal-open');
			this.$nextTick(() => {
				if (this.$refs.dialog) {
					this.$refs.dialog.addEventListener('scroll', this.onScroll);
				}
			});
			setTimeout(() => {
				this.allTabbableElements = tabbable(this.$el);
			});
		}
	}
};
</script>
<style lang="css" scoped>
@import '../../../common/variables.pcss';
.search-modal__close-btn {
	display: none;
}

.search-modal {
	position: absolute;
	width: 100%;
	z-index: 9999;
}

@media (max-width: 991px) {
	.search-modal-frame--styled {
		.search-modal {
			z-index: 9999;
			overflow-y: auto;
		}

		.search-modal--open {
			overflow-y: auto;
		}

		.search-modal-overlay,
		.search-modal {
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			top: 0;
		}

		.search-modal-overlay {
			opacity: 0.5;
			z-index: 9998;
		}

		.search-modal-overlay--light {
			opacity: 0.3;
		}

		.search-modal-overlay--dark {
			opacity: 0.7;
		}

		.search-modal-content {
			position: inherit;
			bottom: 0;
			left: 0;
			right: 0;
			top: 0;
			height: 100vh;
		}

		.search-modal-content--columns .search-modal-heading {
			left: 32px;
			position: absolute;
			top: 40px;
			width: 80%;
		}

		.search-modal-content--white {
			background-color: var(--white);
		}

		.search-modal-content--gray {
			background-color: var(--grey-e5);
		}

		.search-modal__header {
			display: flex;
			align-items: center;
			height: 56px;
			background: var(--white);
		}

		.search-modal-heading h1 {
			width: 100%;
			text-transform: uppercase;
			font: 16px/16px 'semibold', Arial, sans-serif;
			margin: 0;
		}

		.search-modal__body {
			padding: 16px;
			background-color: var(--grey-f5);
		}

		.search-modal__body > :last-child {
			margin-bottom: 0;
		}

		.search-modal__footer {
			margin-top: 32px;
		}

		.search-modal__close-btn {
			background-color: var(--white);
			height: 56px;
			width: 56px;
			border: 0;
			border-right: 1px solid #f5f5f5;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 18px;
		}

		.search-modal__column-narrow {
			background: #eff2f9;
			border-radius: 24px;
			display: none;
			position: relative;
			z-index: 1;
		}

		.search-modal >>> .search-form__advanced {
			color: var(--green);
			font: 16px/16px 'bold', Arial, sans-serif;
			margin-top: 20px;
			margin-bottom: 30px;
		}

		.search-modal >>> .search-form__advanced svg {
			fill: var(--green);
		}

		.search-modal >>> .search-form {
			padding: 0;
		}
	}
}
</style>